import get from 'lodash/get'

export const getEmailSubscriberBlock = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled, value }) => name === 'blockedUsers' && enabled === true)
  if (!enabledFeature) {

    return false

  }

  return enabledFeature.value

}
